<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="header-text">{{ header }}</h3>
    </div>
    <div class="modal-body">
      <p class="body-text">{{ description }}</p>
    </div>
    <div class="modal-footer">
      <button mat-button class="modal-button" (click)="onCancel()">{{'talent-happy-path.buttons.cancel' | translate}}</button>
      <button mat-button class="modal-button" (click)="onConfirm()">{{'talent-happy-path.buttons.yes' | translate}}</button>
    </div>
  </div>
</div>
